export const DomainConfig = {
    hostPattern: 'sephora',
    forceReloadSubdomains: ['www', ''],
};
